module.exports = __webpack_public_path__ + "img/PGR_A05_front_diagonal_en.53afa4ad.png";